/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-27 17:53:06
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-22 00:12:21
 * @FilePath: /goldenSalesMobile/src/api/order.js
 * @Description: 订单相关api
 */
import { requestOfPut, requestOfGet,requestOfDelete } from "../utils/http"
const baseUrl = 'wechath5/zh-cn/v1/order'

// 提交订单
export function submitOrder(param) {
  return requestOfPut(baseUrl, param)
}

// 支付订单
export function payOrder(param) {
  return requestOfPut(`${baseUrl}/pay`, param)
}

// 获取消费者订单列表
export function getUserOrderList(param) {
  return requestOfGet(baseUrl, param)
}

// 订单详情
export function getOrderDetail(param) {
  return requestOfGet(baseUrl, param)
}
// 获取点单记录详情
export function getGoodOrderDetail(param) {
  return requestOfGet(`${baseUrl}/${param.id}`)
}

export function deletedOrderInfo(param) { 
	 return requestOfDelete(`${baseUrl}/${param.id}`)
}
